import { useState } from "react";
import axios from "axios";


const useMARCFile2Json = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([])

    const getMARCFile2JsonData = (params) => {
        onBefore({
            axiosMode: "get",
            api: 'MARCFile2JsonData'
        })
        return axios.get('/koha/bib/MARCFile2Json', {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success",
                            api: 'MARCFile2JsonData',
                            values: data?.data,
                            ...data
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error",
                            api: 'MARCFile2JsonData'
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const postMARCFile2JsonData = (data) => {
        onBefore({ axiosMode: "post", data })
        axios.post('/koha/bib/marcFile2Json', data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then((response) => {
                const result = response.data
                const bSuccess = result?.status === "success";
                console.log({
                    bSuccess
                })
                onFinish({ axiosMode: "post", status: bSuccess ? "success" : "error", values: bSuccess ? result.data : result.message })
                if(bSuccess){
                    setData(result?.data)
                }
                else{
                    setData([])
                }
            })
            .catch((ex) => {
                const errMsg = ex?.response?.data?.message
                    || (ex?.response?.status ? `伺服器錯誤 (HTTP ${ex.response.status})` : null)
                    || (ex?.code === "ERR_NETWORK" ? "無法連線到伺服器或連線逾時" : null)
                    || ex?.message
                    || "檔案解析失敗";
                setData([])
                onFinish({ axiosMode: "post", status: "error", values: { message: errMsg }, ex })
            })
    }
    const patchMARCFile2JsonData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch('/koha/bib/MARCFile2Json',
            data

        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteMARCFile2JsonData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete('/koha/bib/MARCFile2Json',
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    return {
        MARCFile2JsonData: data,
        getMARCFile2JsonData,
        postMARCFile2JsonData,
        patchMARCFile2JsonData,
        deleteMARCFile2JsonData,
    }
}
export { useMARCFile2Json }
